<ng-template #rt let-r="result" let-t="term">
  <span>
    {{ r.name }}
    @if (r.countryCode) {
      <span>({{ r.countryCode }})</span>
    }
  </span>
</ng-template>
<ng-template #rtp let-r="result" let-t="term">
  <span> {{ r.name }}</span>
</ng-template>
<ng-template #rto let-r="result" let-t="term">
  <span>{{ r.name }} {{ r.countryCode | countryCode }}</span>
</ng-template>

@if (
  {
    location_types: (searchParams.location_types | async) || [],
    offices: (searchParams.offices | async) || []
  };
  as data
) {
  <div class="inputs-container" id="hotelSearchForm">
    <mat-radio-group
      [class]="
        data.location_types.length == 6
          ? 'sex-radio-buttons'
          : data.location_types.length == 5
            ? 'quin-radio-buttons'
            : 'quad-radio-buttons'
      "
      [(ngModel)]="searchParams.location_type_select"
      (ngModelChange)="
        hotelLocationChange($event); searchService.isFavoritesSelected = $event === null
      "
      aria-label="Location selection options"
    >
      @for (type of data.location_types; track type) {
        <mat-radio-button
          class="light-primary"
          id="hotel-location-select-{{ type | removeSpaces }}"
          color="primary"
          [value]="type"
        >
          {{ type | translate }}
        </mat-radio-button>
      }
    </mat-radio-group>
    @if (!searchService.isFavoritesSelected) {
      <div class="five-eighths-container flex-row-container--wrap">
        <div class="three-eighth location-wrapper">
          @if (
            searchParams.location_type_select !== LocationTypes.Shortlist &&
            searchParams.location_type_select !== LocationTypes.PropertyNumber
          ) {
            <label class="header-label" id="locationssearch" i18n="@@hotelSearchLocation"
              >Location</label
            >
          }
          @if (searchParams.location_type_select === LocationTypes.Address) {
            <app-search-location-typeahead
              [model]="searchParams.location"
              [country]="country"
              (updateElement)="ensureElementIsScrolledTo($event)"
              (modelChange)="updateLocation($event)"
            >
            </app-search-location-typeahead>
          }
          @if (searchParams.location_type_select === LocationTypes.Office) {
            <div>
              <i class="ico-hotel select-box-icon" aria-hidden="true"></i>
              <input
                appInput
                autocomplete="off"
                i18n-placeholder
                placeholder="Select an Office"
                type="text"
                id="hotel-input-office"
                (click)="$event.target.select()"
                [(ngModel)]="searchParams.office"
                [ngbTypeahead]="searchOffices"
                [resultTemplate]="rto"
                [inputFormatter]="formatter"
                (focus)="focus$.next($event.target.value)"
                [editable]="false"
                aria-labelledby="hotel-office-location-search"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
              <span id="hotel-office-location-search" hidden i18n="@@AriaHotelOfficeLocationSearch"
                >Select an office</span
              >
            </div>
          }
          @if (searchParams.location_type_select === LocationTypes.PropertyNumber) {
            <div>
              <label class="header-label" id="propertySearch" i18n="@@hotelSearchProperty"
                >Property number</label
              >
              <i class="ico-marker select-box-icon" aria-hidden="true"></i>
              <input
                appInput
                [(ngModel)]="searchParams.propertyNumber"
                i18n-placeholder
                placeholder="Enter property number"
              />
              <span id="hotel-property-number-search" hidden i18n="@@AriaHotelPropertyNumberSearch"
                >Add a property number</span
              >
            </div>
          }

          <!-- Department's choice of preferred CHP properties -->
          @if (searchParams.location_type_select === LocationTypes.Shortlist) {
            <app-search-country
              [(country)]="searchParams.country"
              [countries]="searchService.countries"
              (countryChange)="countryChange($event)"
              title="Country"
              i18n-title
            >
            </app-search-country>
          }
          <!-- Department's choice of preferred CHP properties -->
        </div>
        <div class="five-eighth search-input-wrapper">
          <div class="input-container">
            <label
              class="header-label date-label"
              id="checkinlabel"
              for="hotel-checkin-date"
              i18n="@@apartmentSearchOutboundDateAndTime"
              >Check-in date (DD/MM/YYYY)</label
            >
            <div
              [ngClass]="{
                'error-box':
                  !searchService.isFavouriteSearch &&
                  searchParams.validationMessages?.includes('Checkin date must not be in the past')
              }"
            >
              <ngbd-datepicker-i18n>
                <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
                <app-datepicker
                  [minDate]="searchParams.min_date"
                  [startDate]="searchParams.checkin_date"
                  [model]="searchParams.checkin_date_ngb"
                  [from]="searchParams.checkin_date_ngb"
                  [to]="searchParams.checkout_date_ngb"
                  (newFrom)="searchParams.checkin_date_ngb = $event"
                  (newTo)="searchParams.checkout_date_ngb = $event"
                  [class]="'combo-box'"
                  [componentId]="'hotel-checkin-date'"
                  (newDate)="searchParams.checkin_date_ngb = $event"
                >
                </app-datepicker>
              </ngbd-datepicker-i18n>
            </div>
          </div>
          <div class="input-container">
            <label
              class="header-label date-label"
              id="checkoutlabel"
              for="hotel-checkout-date"
              i18n="@@apratmentSearchReturnDateAndTime"
              >Check-out date (DD/MM/YYYY)</label
            >
            <ngbd-datepicker-i18n>
              <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
              <app-datepicker
                [minDate]="searchParams.min_date"
                [startDate]="searchParams.checkout_date || searchParams.checkin_date_ngb"
                [model]="searchParams.checkout_date_ngb"
                [from]="searchParams.checkin_date_ngb"
                [to]="searchParams.checkout_date_ngb"
                (newFrom)="searchParams.checkin_date_ngb = $event"
                (newTo)="searchParams.checkout_date_ngb = $event"
                [class]="'combo-box'"
                [componentId]="'hotel-checkout-date'"
                (newDate)="searchParams.checkout_date_ngb = $event"
              >
              </app-datepicker>
            </ngbd-datepicker-i18n>
          </div>
          <div class="input-container">
            <label
              class="header-label"
              id="noofrooms"
              for="hotel-input-noofrooms"
              i18n="@@hotelSearchNoOfRooms"
              >No of rooms</label
            >
            <i class="ico ico-new-user input-box-icon"></i>
            <input
              appInput
              type="number"
              name="room_no"
              min="1"
              step="1"
              max="{{ limitRoomCountPerTraveller() }}"
              [roomNoValidate]="limitRoomCountPerTraveller()"
              [(ngModel)]="searchParams.no_of_rooms"
              i18n-placeholder
              placeholder="Enter number of rooms."
              aria-labelledby="noofrooms"
              id="hotel-input-noofrooms"
              [ngClass]="{
                'error-box': searchParams.validationMessages?.includes(
                  'Occupants per room must be 1 or 2; if you have an odd number of travellers (greater than one); the no of rooms must be equal'
                )
              }"
              (ngModelChange)="searchParams.rooms_error = false"
            />
          </div>
          <div class="input-container">
            <label
              class="header-label"
              id="within"
              for="hotel-within-select"
              i18n="@@hotelSearchWithinDistance"
              >Within distance</label
            >
            <select
              appSelect
              [noIcon]="true"
              [(ngModel)]="searchParams.distance"
              aria-labelledby="within"
              id="hotel-within-selec"
            >
              @for (value of searchParams.distance_list; track value) {
                <option [ngValue]="value">
                  {{ value | switchDistanceFormat: userDistanceUnit : true | number: '1.0-0' }}
                  @if (userDistanceUnit === 'Miles') {
                    @if (value === 1) {
                      <span i18n="@@hotelSearchMile">mile</span>
                    }
                    @if (value > 1) {
                      <span i18n="@@hotelSearchMiles">miles</span>
                    }
                  }
                  @if (userDistanceUnit !== 'Miles') {
                    <span class="distance_unit">{{ userDistanceUnit | lowercase }}</span>
                  }
                </option>
              }
            </select>
          </div>
        </div>
      </div>

      @if (showOptions) {
        <div>
          <div class="flex-row-container">
            <h2 class="header-label rem-1-5" i18n="@@hotelSearchOptions">Options</h2>
          </div>
          <div class="half-container">
            <div class="half-block">
              <label
                class="header-label"
                id="hotelname"
                for="hotel-input-hotelname"
                i18n="@@hotelSearchHotelName"
                >Hotel name</label
              >
              <i class="ico-home input-box-icon" aria-hidden="true"></i>
              <input
                appInput
                autocomplete="off"
                i18n-placeholder
                id="hotel-input-hotelname"
                placeholder="Enter a hotel name"
                [(ngModel)]="searchParams.hotel_name"
                aria-labelledby="hotelname"
              />
            </div>
            <div class="half-block">
              <label
                class="header-label"
                id="hotelchain"
                for="hotel-input-hotelchain"
                i18n="@@hotelSearchHotelchain"
                >Hotel chain</label
              >
              <i class="ico-home combo-box-icon" aria-hidden="true"></i>
              <input
                autocomplete="off"
                class="combo-box"
                i18n-placeholder
                placeholder="Enter a hotel chain"
                [(ngModel)]="searchParams.hotel_chain"
                [ngbTypeahead]="searchChains"
                [resultTemplate]="rtp"
                id="hotel-input-hotelchain"
                [inputFormatter]="chainFormatter"
                aria-labelledby="hotelchain"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
            </div>
          </div>
          <br />
          @if (crownSet) {
            <div class="half-container">
              <div class="half-block">
                <mat-checkbox
                  color="primary"
                  class="light-primary"
                  name="crownOnly"
                  value="crownOnly"
                  [(ngModel)]="searchParams.crownRatesOnly"
                  aria-label="Crown rates only"
                >
                  <span i18n="@@hotelCrownOnly">Crown rates only</span>
                </mat-checkbox>
              </div>
            </div>
          }
        </div>
      }
    } @else {
      <app-favorite-items [serviceType]="ServiceType.Hotel"> </app-favorite-items>
    }
  </div>
  <!-- Loading Spinner - show when fetching data from backend -->
}
<app-hotel-loading-screen></app-hotel-loading-screen>
